// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9535b1d","453":"351b5fdc","732":"9114c062"}[chunkId] + ".chunk.js";
};